import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';
import Color from 'color';
import {
  BarChart, Bar, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis,
} from 'recharts';
import typesTypes from './prop-types';
import { LwColumnChartStyles } from '../../common/styles';
import Toolty from './toolty';

const Container = styled.div`
  width: 100%;
  height: 100%;

  & svg {
    pointer-events: all;
    ${LwColumnChartStyles};

    .recharts-cartesian-grid {
      transform: translateY(10px);

      line {
        stroke: #e8edf1;
        :nth-last-child(-n + 2) {
          visibility: hidden;
        }
      }
    }
  }
`;

const gradColor = i => Color('#475b6c').lighten(i * 1.56 / 9).rgb().toString();

const noMargin = {
  top: 0, right: 0, left: 0, bottom: 0,
};

const xPad = { left: 0, right: 80 };

export default function ChartArea({
  types,
  // Injections to make this testable
  IContainer, IBarChart, IBar, ICell,
}) {
  const [active, setActive] = React.useState(null);
  const onEnterBar = data => setActive(data.type);
  const onLeaveBar = () => setActive(null);

  return (
    <div className="chart">
      <Container nonFixedBarColor>
        <IContainer>
          <IBarChart layout="vertical" data={types} barSize={20} margin={noMargin}>
            <CartesianGrid vertical={false} horizontal />
            <YAxis dataKey="type" type="category" hide />
            <XAxis dataKey="count" type="number" padding={xPad} hide />
            <IBar dataKey="count" onMouseEnter={onEnterBar} onMouseLeave={onLeaveBar}>
              {types.map(({ type }, i) => (
                <ICell
                  key={`bar-cell-${type}`}
                  className={classNames({ active: type === active })}
                  fill={gradColor(i)}
                />
              ))}
            </IBar>
            <Tooltip offset={6} isAnimationActive={false} content={Toolty} cursor={false} />
          </IBarChart>
        </IContainer>
      </Container>
    </div>
  );
}

ChartArea.propTypes = {
  types: typesTypes.isRequired,
  IContainer: PropTypes.elementType,
  IBarChart: PropTypes.elementType,
  IBar: PropTypes.elementType,
  ICell: PropTypes.elementType,
};

ChartArea.defaultProps = {
  IContainer: ResponsiveContainer,
  IBarChart: BarChart,
  IBar: Bar,
  ICell: Cell,
};
